// Some fields are duplicate to support both AddressProofType and DocumentType in backend
export enum DocumentType {
    Aadhaar = 'aadhaar',
    DrivingLicense = 'drivinglicense',
    Driving = 'driving',
    VoterId = 'voterid',
    Voter = 'voter',
    Passport = 'passport',
    LpgBill = 'lpg',
    TelephoneBill = 'telephone',
    ElectricityBill = 'electricity',
    Photo = 'photo',
    Itr = 'itr',
    SalarySlip = 'salary',
    Pan = 'pan'
}

export class DocumentTypeModel {
  private static documentTypeMap = new Map<DocumentType, string>()
    .set(DocumentType.Aadhaar, 'Aadhaar')
    .set(DocumentType.VoterId, 'Voter ID')
    .set(DocumentType.Passport, 'Passport')
    .set(DocumentType.TelephoneBill, 'MTNL/BSNL bill')
    .set(DocumentType.DrivingLicense, 'Driving license')
    .set(DocumentType.ElectricityBill, 'Electricity bill')
    .set(DocumentType.LpgBill, 'LPG bill')
    .set(DocumentType.Itr, 'ITR Statement')
    .set(DocumentType.Pan, 'PAN card')
    .set(DocumentType.Photo, 'Photo')
    .set(DocumentType.SalarySlip, 'Salary slip');

  public static getDisplayableDocumentType(document: any): string {
    if (this.documentTypeMap.has(document)) {
      return this.documentTypeMap.get(document);
    } else {
      return '';
    }
  }
}
